export function websiteBuilderAddLinkProtocol(url: string): string {
  return url?.toLowerCase().startsWith("www.") ? `https://${url}` : url;
}